import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  // base_url = environment.base_domain_url;
  constructor(private pageTitle: Title, private meta: Meta) {}

  setMetaTags(description: string, title: string): void {
    const descriptionWithoutTags = description
      ? description.replace(/<\/?[^>]+(>|$)/g, '')
      : '';
    const titleWithoutTags = title ? title.replace(/<\/?[^>]+(>|$)/g, '') : '';

    if (descriptionWithoutTags) {
      this.meta.updateTag(
        { name: 'description', content: descriptionWithoutTags },
        `name='description'`
      );
    } else {
      console.warn('Description is empty or invalid.');
    }

    if (titleWithoutTags) {
      this.pageTitle.setTitle(titleWithoutTags);
    } else {
      console.warn('Title is empty or invalid.');
    }
  }
  setCanonicalURL(url?: string) {
    const canURL = url === undefined ? window.location.href : url;
    let link = this.meta.getTag('rel=canonical') as unknown as HTMLLinkElement;
    if (link) {
      link.setAttribute('href', canURL);
    } else {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', canURL);
      document.head.appendChild(link);
    }
  }
}
